import React, { forwardRef } from 'react';

export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: string;
}

/**
 * KERN Checkbox Component
 *
 * Usage:
 * <Checkbox label="Ich stimme den AGB zu" name="agb" />
 */
export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, id, className = '', ...props }, ref) => {
    const checkboxId = id || `checkbox-${label.toLowerCase().replace(/\s+/g, '-')}`;

    return (
      <div className={`kern-form-check ${className}`}>
        <input
          ref={ref}
          className="kern-form-check__checkbox"
          id={checkboxId}
          type="checkbox"
          {...props}
        />
        <label className="kern-label" htmlFor={checkboxId}>
          {label}
        </label>
      </div>
    );
  }
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;
